import React from 'react'

function FpoManage() {
    return (
        <div>FpoManage</div>
    )
}

export default FpoManage